/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a loan amount, rate, and term.`)
};

const es_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese un monto de préstamo, tasa y plazo.`)
};

const de_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Darlehensbetrag, einen Zinssatz und eine Laufzeit ein.`)
};

const nl_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een leningbedrag, rente en looptijd in.`)
};

const fr_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un montant de prêt, un taux et une durée.`)
};

const it_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserire un importo del prestito, un tasso e una durata.`)
};

const pt_br2_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um montante do empréstimo, uma taxa e um prazo.`)
};

const pt_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um montante de empréstimo, uma taxa e um prazo.`)
};

const ja_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ローン金額、金利、期間を入力してください。」`)
};

const zh_ln_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入贷款金额、利率和期限。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_invalid", locale)
	if (locale === "en") return en_ln_invalid(inputs)
	if (locale === "es") return es_ln_invalid(inputs)
	if (locale === "de") return de_ln_invalid(inputs)
	if (locale === "nl") return nl_ln_invalid(inputs)
	if (locale === "fr") return fr_ln_invalid(inputs)
	if (locale === "it") return it_ln_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_ln_invalid(inputs)
	if (locale === "pt") return pt_ln_invalid(inputs)
	if (locale === "ja") return ja_ln_invalid(inputs)
	return zh_ln_invalid(inputs)
};